import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { authReducer } from './auth';
import { loadingReducer } from './loading';
import { uiReducer } from './ui';
import { clientesReducer } from './clientes';
import { usuariosReducer } from './usuarios';
import { perfilReducer } from './perfil';
import { userReducer } from './user';
import { modalContainerReducer } from './modal-container';
import { vendedorReducer } from './vendedor';
import { produtoReducer } from './produto';
import { faturamentoReducer } from './faturamento';
import { planoVelesReducer } from './planoVeles';
import { produtoClienteReducer } from './produtoCliente';
import { limitacaoConsumoReducer } from './limitacao-consumo';
import { relatoriosDashSlice } from './relatorios-dash';
import { ipPermitidoReducer } from './ip-permitido';
import { dashboardSummaryReducer } from './dashboard-summary';

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false
})

export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    ui: uiReducer,
    clientes: clientesReducer,
    usuarios: usuariosReducer,
    perfil: perfilReducer,
    user: userReducer,
    modalContainer: modalContainerReducer,
    vendedor: vendedorReducer,
    produto: produtoReducer,
    produtoCliente: produtoClienteReducer,
    faturamento: faturamentoReducer,
    planoVeles: planoVelesReducer,
    limitacaoConsumo: limitacaoConsumoReducer,
    relatoriosDash: relatoriosDashSlice.reducer,
    ipPermitido: ipPermitidoReducer,
    dashboardSummary: dashboardSummaryReducer
  },
  middleware: customizedMiddleware
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;